export const PES_SPRYKER_ENDPOINTS = [
  'https://glue.pes-sqe.se.com',
  'https://glue.pes-stg.cloud.spryker.toys',
  'https://glue.pes.se.com',
];

export const APP_TYPES = [
  { text: 'PES Business Service', value: 'pesCatalog' },
  { text: 'Commerce Connector', value: 'commerceConnector' },
];

export const PAGES = [
  { text: 'All products', value: '' },
  { text: 'Category', value: 'category' },
  { text: 'Subcategory', value: 'subcategory' },
  { text: 'Range (prp)', value: 'range' },
  { text: 'Product (pdp)', value: 'product' },
];

export const DIR_TYPES = [
  { text: 'ltr', value: 'ltr' },
  { text: 'rtl', value: 'rtl' },
  { text: 'auto', value: 'auto' },
];
